// Module
var code = "<h1 id=filelink-文件链接>FileLink 文件链接</h1> <p>用于预览、下载、批量下载文件。</p> <p>提供统一的文件链接操作。</p> <h2 id=何时使用>何时使用</h2> <ul> <li>...。</li> </ul> ";
// Exports
module.exports = code;